import { useRuntimeConfig } from "#app";
import { createConsola } from "consola";
const logger = createConsola({
  defaults: {
    tag: "\u{1F4AC} msg"
  }
});
export const useDebugLogger = () => {
  const config = useRuntimeConfig();
  const isDebugMode = config.public?.nuxtMessagingDebug || false;
  return {
    log: (message, ...args) => {
      if (isDebugMode) logger.info(message, ...args);
    },
    error: (message, ...args) => {
      if (isDebugMode) logger.error(message, ...args);
    }
  };
};
